import React from 'react';
import styled from 'styled-components';
import { ErrorProps } from '../types';

const ErrorContainer = styled.div`
  text-align: center;
  padding: 2.4rem;
`;

const ErrorMessage = styled.p`
  font-size: 1.8rem;
  font-weight: 500;
  padding: 2rem;
  background-color: var(--color-dark);
  border-radius: 100px;
  color: var(--color-accent);
`;

const ErrorIcon = styled.span`
  font-size: 2.4rem;
  margin-right: 0.8rem;
`;

const Error: React.FC<ErrorProps> = () => {
  return (
    <ErrorContainer>
      <ErrorMessage>
        <ErrorIcon>💥</ErrorIcon> There was an error fetching questions.
      </ErrorMessage>
    </ErrorContainer>
  );
};

export default Error;
